import script from "./SearchAndSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchAndSelect.vue?vue&type=script&setup=true&lang=ts"

import "./SearchAndSelect.vue?vue&type=style&index=0&id=1fc986d6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src014250190/src/byggesoknaden-support-gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc986d6"]])

export default __exports__